import { fetcher } from "./gameserver";

export const getBlogFeed = async () => {
  const method = "GET";
  return fetcher({ method, subject: "feed" }, "")(`/public/blog/feed`);
};
